import { memo } from 'react';
import {
    Box,
} from '@mui/material';
import {
    Contenedor,
} from './components';

export const SecondComponent = memo(() => {

    return ( 
        <Box
            sx={{
                minHeight: `calc(100vh - 120px)`,
                maxHeight: `calc(100vh - 120px)`,
                height: `calc(100vh - 120px)`,
                overflowY: "auto",
                overflowX: "hidden",
                position: "relative",
                pt: 6,
                pb: 2,
                width: "100%",
            }}>
            <Contenedor />
        </Box>
    )
});




